import React from 'react';
import Lottie from 'lottie-react';
import loaderJson from './../../../Assets/DMS-Loader.json'; 
import './Loader.scss';

const Loader = () => {
  return (
    <div className="loader-container" >
      <Lottie
      style={{ height: '250px', width: '250px',color:'green'}} 
        animationData={loaderJson} 
        loop={true} 
        className="loader-animation" 
      />
    </div>
  );
};

export default Loader;
